import {Injectable, OnDestroy, signal} from "@angular/core"

@Injectable({providedIn: "root"})
export class DevicePixelRatioService implements OnDestroy {
    private readonly _devicePixelRatio = signal<number>(window.devicePixelRatio)
    readonly $devicePixelRatio = this._devicePixelRatio.asReadonly()

    private mediaQueryList?: MediaQueryList
    private listener?: () => void
    private started = false
    constructor() {
        this.start()
    }

    private start(): void {
        if (this.started) return
        this.started = true
        this.startListeningInternal()
    }

    private stop(): void {
        if (!this.started) return
        this.started = false
        this.stopListeningInternal()
    }

    private startListeningInternal(): void {
        this.stopListeningInternal()
        const current = window.devicePixelRatio
        this._devicePixelRatio.set(current)
        this.mediaQueryList = window.matchMedia(`(resolution: ${current}dppx)`)
        this.listener = () => {
            const newValue = window.devicePixelRatio
            if (newValue !== this._devicePixelRatio()) {
                this._devicePixelRatio.set(newValue)
            }
            if (this.started) this.startListeningInternal()
        }
        this.mediaQueryList.addEventListener("change", this.listener)
    }

    private stopListeningInternal(): void {
        if (this.mediaQueryList && this.listener) {
            this.mediaQueryList.removeEventListener("change", this.listener)
        }
        this.mediaQueryList = undefined
        this.listener = undefined
    }

    getCurrent(): number {
        return this._devicePixelRatio()
    }

    ngOnDestroy(): void {
        this.stop()
    }
}
